/* ==========================================
   LOGIN BLOG PAGE
   Lightweight Scroll Reveal
========================================== */

document.addEventListener('DOMContentLoaded', function () {

  const blogPage = document.querySelector('.login-blog-page');

  if (!blogPage) return;


  /* ==========================================
     REDUCED MOTION
  ========================================== */

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  if (reducedMotion) {
    blogPage.classList.add('login-blog-page--ready');
    return;
  }


  /* ==========================================
     BLOG CARDS
  ========================================== */

  const cards = blogPage.querySelectorAll(
    '.login-blog-page__card'
  );

  if (!cards.length) return;


  /* ==========================================
     INITIAL STATE
  ========================================== */

  cards.forEach(function (card) {
    card.classList.add('login-blog-page__reveal');
  });


  /* ==========================================
     INTERSECTION OBSERVER
  ========================================== */

  if ('IntersectionObserver' in window) {

    const observer = new IntersectionObserver(
      function (entries, observer) {

        entries.forEach(function (entry) {

          if (!entry.isIntersecting) return;

          entry.target.classList.add(
            'login-blog-page__reveal--visible'
          );

          observer.unobserve(entry.target);

        });

      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -40px 0px'
      }
    );


    cards.forEach(function (card) {
      observer.observe(card);
    });

  } else {

    /* ==========================================
       FALLBACK
    ========================================== */

    cards.forEach(function (card) {
      card.classList.add(
        'login-blog-page__reveal--visible'
      );
    });

  }


  /* ==========================================
     PAGE READY
  ========================================== */

  blogPage.classList.add(
    'login-blog-page--ready'
  );

});